import React, { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import { Box, Chip, Grid, Radio, Switch } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import dayjs from "dayjs";
import { itemsPerPage } from "../../utils/constants";
import TablePagination from "../../common/tablePagination";
import Searchbar from "../../common/searchbar";
import capRegistrationActions from "../../redux/capRegistration/actions";
export default function CapCourseTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { backofficeTokenDetails } = useSelector((state) => state.authReducer);

  const [searchTerm, setSearchTerm] = useState("");
  const { courseList } = useSelector((state) => state.masterReducer);
  const { capCourseList } = useSelector((state) => state.capReducer);
  const [tableData, setTableData] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    createTabledata();
  }, [capCourseList, searchTerm,courseList]); // <-- added searchTerm
  
  console.log('capCourseList--',capCourseList);
  console.log('courseList--',courseList);
  
  const handleActive = (active, type, courseid) => {
    console.log("testt");
    console.log("testt",active, type, courseid);
    
      dispatch({
        type: capRegistrationActions?.UPDATE_CAP_COURSE_STATUS,
        payload: { capCourseid:courseid,status:type },
      });
    
  };
  // const createTabledata = () => {
  //   let data = courseList.all.map((obj) => {
  //     return {
  //       ...obj,
  //       coursecategory: obj.coursecategory,
  //       coursename: obj.coursename,
  //       regstartdate: dayjs(obj.regstartdate).format("DD-MM-YYYY"),
  //       regenddate: dayjs(obj.regenddate).format("DD-MM-YYYY"),
  //       isActive: obj.isActive,
  //       courseid: obj.courseid,
  //       enable: (
  //         <Radio
  //           checked={obj.isactive === "1"}
  //           onClick={() => handleActive(obj.isactive, "1", obj.courseid)}
  //         />
  //       ),
  //       disable: (
  //         <Radio
  //           checked={obj.isactive === "0"}
  //           onClick={() => handleActive(obj.isactive, "0", obj.courseid)}
  //         />
  //       ),
  //     };
  //   });
  //   setTableData(data);
  // };

  const createTabledata = () => {
    const filtered = capCourseList?.filter((obj) =>
      obj.coursename.toLowerCase().includes(searchTerm.toLowerCase())
    )
    const data = filtered?.map((obj, index) => ({
      ...obj,
      id: index + 1,
      coursecategory: obj.coursecategory,
      coursename: obj.coursename,
      regstartdate: dayjs(obj.regstartdate).format("DD-MM-YYYY"),
      regenddate: dayjs(obj.regenddate).format("DD-MM-YYYY"),
      isActive: obj.isActive,
      courseid: obj.courseid,
      exams: (
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            maxWidth: "100%",
            overflow: "hidden",
          }}
        >
          {obj?.exams ? (
            <Chip
              key={obj.exams}
              label={
                courseList?.all?.find((c) => c.courseid === obj.exams)?.coursename ||
                "Unknown Course"
              }
              sx={{
                borderRadius: "16px",
                backgroundColor: "#f0f4ff",
                color: "#333",
                fontWeight: 500,
                px: 2,
              }}
            />
          ) : null}
        </Box>
      ),
      coursecategory:obj?.coursecategory == 6 ? "UG":obj?.coursecategory == 1 ? "PG":"",
      enable: (
        <Radio
          checked={obj.isactive === "1"}
          onClick={() => handleActive(obj.isactive, "1", obj.courseid)}
        />
      ),
      toggle:(
        <Switch
          checked={obj.status == "1"}
          onChange={(checked) =>
            handleActive(obj.status, obj.status == 1 ? "0" : "1", obj.capcourseid)
          }
          checkedChildren="On"
          unCheckedChildren="Off"
        />
      )
    }));

    setTableData(data || []);
  };
  useEffect(() => {
    dispatch({ type: masterActions.GET_COURSE_LIST });
    dispatch({ type: capRegistrationActions.GET_ALL_CAP_COURSE });
  }, []);
  const tableKeys = [
    {
      name: "S.No",
      accessor: "capcourseid",
      sortOption: false,
    },
    {
      name: "UG/PG",
      accessor: "coursecategory",
      sortOption: false,
    },
    {
      name: "Exam",
      accessor: "exams",
      sortOption: false,
    },
    {
      name: "Course",
      accessor: "coursename",
      sortOption: false,
    },
    // {
    //   name: "Registration End Date",
    //   accessor: "regenddate",
    //   sortOption: false,
    // },

    {
      name: "Status",
      accessor: "toggle",
      sortOption: false,
    },
    
  ];

  const defaultValues = [
    {
      coursecategory: "Science",
      coursename: "Physics 101",
      startdate: "2023-01-01",
      enddate: "2023-05-01",
      manual: "Manual A",
      enable: false,
      disable: false,
    },
    {
      coursecategory: "Arts",
      coursename: "History 101",
      startdate: "2023-02-01",
      enddate: "2023-06-01",
      manual: "Manual B",
      enable: false,
      disable: false,
    },
  ];

  const handleCourseUpdate = (value) => {
    navigate(
      `/${Cookies.get("mhet_mst_project")}/cap-course-management?page=addcapcourse&id=${value?.capcourseid}`,
      { state: { id: value.capcourseid } }
    );
  };

  const handlCourseCreate = (value) => {
    navigate(
      `/${Cookies.get("mhet_mst_project")}/cap-course-management?page=addcapcourse`,
      { state: { id: value.courseid, coursename: value?.coursename } }
    );
  };

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = tableData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(tableData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  return (
    <Grid>
      <Grid item lg={7} md={7} sm={12} style={{marginBottom:"5px"}}>
        <Searchbar handleSearch={handleSearch} value={searchTerm} />
      </Grid>
      <DataTable
        keys={tableKeys}
        values={currentItems}
        page={"capcourseList"}
        handleCourseUpdate={handleCourseUpdate}
        handlCourseCreate={handlCourseCreate}
      />
      <TablePagination
        pageCount={pageCount}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
      />
    </Grid>
  );
}
